export interface BlogPost {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  authorRole: string;
  date: string;
  readTime: number;
  image: string;
  tags: string[];
  featured: boolean;
}

export const blogPosts: BlogPost[] = [
  {
    id: 1,
    slug: 'laminam-ultra-thin-ceramic-guide',
    title: 'Laminam ულტრა-თხელი კერამიკა: სრული გზამკვლევი',
    excerpt: 'გაიგეთ ყველაფერი Laminam-ის 3მმ ულტრა-თხელი კერამიკული ფილების შესახებ — მონტაჟიდან მოვლამდე.',
    content: `Laminam-ის ულტრა-თხელი კერამიკული ფილები რევოლუციას ახდენს ინტერიერის დიზაინში. 3მმ სისქის ფილა, რომელიც 1000x3000მმ ზომისაა, ქმნის სრულიად უწყვეტ ზედაპირს.

**რატომ Laminam?**

Laminam-ის ფილები მზადდება სპეციალური პრესირების ტექნოლოგიით, რომელიც ბუნებრივი ქვის ეფექტს ზუსტად ასახავს. ფილის ზედაპირი ჰიგიენურია, UV-გამძლე და ადვილად სუფთავდება.

**მონტაჟის ძირითადი წესები**

1. ზედაპირი უნდა იყოს სრულიად სწორი — 2მმ-ზე მეტი გადახრა დაუშვებელია
2. გამოიყენეთ Laminam-ის სპეციალური C2TE S1 კლასის წებო
3. ჭრა ხდება მხოლოდ ბრილიანტის დისკით, წყლის გაგრილებით
4. ფუგა: მინიმუმ 2მმ, ეპოქსიდური ფუგა რეკომენდებულია

**მოვლა**

Laminam-ის ფილები პრაქტიკულად უვარგისია ლაქებისთვის. ყოველდღიური სუფთავება — ნეიტრალური pH სარეცხი საშუალებით. ქიმიური გამწმენდები — დაუშვებელია.`,
    category: 'პროდუქტის გზამკვლევი',
    author: 'გიორგი მამულაშვილი',
    authorRole: 'ტექნიკური სპეციალისტი',
    date: '2026-04-15',
    readTime: 6,
    image: 'https://readdy.ai/api/search-image?query=Laminam%20ultra%20thin%20ceramic%20tile%20installation%20process%20professional%20worker%20applying%20large%20format%20marble%20look%20slab%20modern%20interior%20warm%20lighting&width=800&height=500&seq=blog-1-phoenix&orientation=landscape',
    tags: ['Laminam', 'კერამიკა', 'მონტაჟი', 'გზამკვლევი'],
    featured: true,
  },
  {
    id: 2,
    slug: 'natural-stone-vs-ceramic-comparison',
    title: 'ბუნებრივი ქვა vs კერამიკა: რომელი აირჩიოთ?',
    excerpt: 'დეტალური შედარება ბუნებრივ ქვასა და კერამიკულ ფილებს შორის — ფასი, მოვლა, გამძლეობა.',
    content: `ბუნებრივი ქვა და კერამიკა — ორი ყველაზე პოპულარული მასალა პრემიუმ ინტერიერებში. მაგრამ რომელი ჯობია?

**ბუნებრივი ქვა — უპირატესობები**

ბუნებრივი მარმარილო, გრანიტი და ტრავერტინი ყოველი ნიმუში უნიკალურია. ბუნებრივი ქვა ათწლეულების განმავლობაში ინარჩუნებს სილამაზეს. სწორი მოვლით — 50+ წელი.

**კერამიკა — უპირატესობები**

Laminam-ის კერამიკული ფილები ბუნებრივი ქვის ეფექტს ზუსტად ასახავს, მაგრამ ბევრად ადვილი მოვლით. ქიმიური გამძლეობა, UV-გამძლეობა და ჰიგიენური ზედაპირი.

**ფასი**

ბუნებრივი ქვა: 150-800 GEL/მ²
კერამიკა (Laminam): 200-400 GEL/მ²

**დასკვნა**

სასტუმრო, ვანის ოთახი, სამზარეულო — კერამიკა. ლობი, ექსკლუზიური ინტერიერი — ბუნებრივი ქვა.`,
    category: 'შედარება',
    author: 'ნინო ჩიქოვანი',
    authorRole: 'ინტერიერის დიზაინერი',
    date: '2026-04-08',
    readTime: 8,
    image: 'https://readdy.ai/api/search-image?query=Natural%20marble%20stone%20slab%20versus%20ceramic%20tile%20comparison%20luxury%20interior%20design%20showroom%20warm%20lighting%20professional%20photography&width=800&height=500&seq=blog-2-phoenix&orientation=landscape',
    tags: ['ბუნებრივი ქვა', 'კერამიკა', 'შედარება', 'ინტერიერი'],
    featured: true,
  },
  {
    id: 3,
    slug: 'ardex-waterproofing-bathroom-guide',
    title: 'Ardex-ით ვანის ოთახის ჰიდროიზოლაცია: ნაბიჯ-ნაბიჯ',
    excerpt: 'პროფესიონალური ჰიდროიზოლაციის სრული გზამკვლევი Ardex WPM 300 სისტემით.',
    content: `ვანის ოთახის ჰიდროიზოლაცია — ყველაზე მნიშვნელოვანი ეტაპი, რომელსაც ხშირად უგულებელყოფენ. Ardex WPM 300 სისტემა პროფესიონალური გადაწყვეტილებაა.

**საჭირო მასალები**

- Ardex P 51 გრუნტი
- Ardex WPM 300 ჰიდროიზოლაციის მემბრანა
- Ardex სპეციალური ლენტი კუთხეებისთვის
- Ardex K 80 Flex წებო ფილებისთვის

**ნაბიჯ-ნაბიჯ პროცესი**

1. **გრუნტი**: Ardex P 51 გამოიყენეთ ყველა ზედაპირზე. გამოშრობა: 30 წუთი.
2. **პირველი ფენა**: WPM 300 A+B კომპონენტები შეურიეთ. გამოიყენეთ ფუნჯით. სისქე: 1მმ.
3. **ლენტი**: კუთხეებსა და ნაკერებზე Ardex-ის სპეციალური ლენტი.
4. **მეორე ფენა**: 4-6 საათის შემდეგ მეორე ფენა. სრული სისქე: 2მმ.
5. **გამოშრობა**: 24 საათი. შემდეგ — ფილების მონტაჟი.

**მნიშვნელოვანი**

ჰიდროიზოლაცია უნდა ადიოდეს კედელზე მინიმუმ 20სმ-ით. შხაპის ზონაში — 200სმ-მდე.`,
    category: 'ინსტალაციის გზამკვლევი',
    author: 'დავით კვარაცხელია',
    authorRole: 'სამშენებლო ინჟინერი',
    date: '2026-03-28',
    readTime: 7,
    image: 'https://readdy.ai/api/search-image?query=Professional%20waterproofing%20application%20bathroom%20construction%20worker%20applying%20membrane%20coating%20wet%20room%20preparation%20warm%20lighting&width=800&height=500&seq=blog-3-phoenix&orientation=landscape',
    tags: ['Ardex', 'ჰიდროიზოლაცია', 'ვანის ოთახი', 'მონტაჟი'],
    featured: false,
  },
  {
    id: 4,
    slug: 'epoxy-resin-floor-design-trends',
    title: '2026 წლის ეპოქსიდური იატაკის ტრენდები',
    excerpt: 'Tecnopol-ის ეპოქსიდური სისტემებით შექმნილი ყველაზე პოპულარული ეფექტები 2026 წელს.',
    content: `ეპოქსიდური იატაკი 2026 წელს ახალ სიმაღლეებს აღწევს. Tecnopol-ის EPOX 500 სისტემა ყველაზე პოპულარული გადაწყვეტილებაა.

**ტოპ ტრენდები 2026**

**1. მეტალიკური ეფექტი**
ვერცხლისფერი, ოქროსფერი და სპილენძის ეფექტები. Tecnopol EPOX 500 3-კომპონენტიანი სისტემა ქმნის სიღრმისეულ, ცოცხალ ეფექტს.

**2. მიკრო-ცემენტის ეფექტი**
Tecnopol PU 2000 პოლიურეთანის სისტემა ქმნის მიკრო-ცემენტის ეფექტს — ბეტონის ვიზუალი, ეპოქსიდის სიმტკიცე.

**3. 3D ეფექტი**
სპეციალური ტექნიკით შექმნილი სამგანზომილებიანი ეფექტი. ყველაზე ექსკლუზიური ვარიანტი.

**4. ბუნებრივი ტონები**
ბეჟი, ქვიშის, ტერაკოტას ტონები — ბუნებრივ მასალებთან ჰარმონიაში.

**ღირებულება**

Tecnopol ეპოქსიდური სისტემა: 45-120 GEL/მ² (მასალა + სამუშაო)`,
    category: 'ტრენდები',
    author: 'ანა გელაშვილი',
    authorRole: 'ინტერიერის დიზაინერი',
    date: '2026-03-15',
    readTime: 5,
    image: 'https://readdy.ai/api/search-image?query=Metallic%20epoxy%20resin%20floor%20glossy%20silver%20gold%20effect%20modern%20luxury%20interior%20design%20warm%20lighting%20professional%20photography&width=800&height=500&seq=blog-4-phoenix&orientation=landscape',
    tags: ['Tecnopol', 'ეპოქსიდი', 'ტრენდები', 'ფრიალი იატაკი'],
    featured: false,
  },
  {
    id: 5,
    slug: 'acoustic-ceiling-office-guide',
    title: 'სამუშაო სივრცის აკუსტიკა: Armstrong-ის გადაწყვეტილებები',
    excerpt: 'როგორ შეამციროთ ხმაური ოფისში Armstrong Ultima+ აკუსტიკური ჭერის სისტემით.',
    content: `ოფისის აკუსტიკა პირდაპირ გავლენას ახდენს პროდუქტიულობაზე. კვლევები აჩვენებს, რომ ხმაური 66%-ით ამცირებს კონცენტრაციას.

**Armstrong Ultima+ — რატომ?**

Armstrong Ultima+ ფლობს Class A ხმის შთანთქმის სერთიფიკატს — ყველაზე მაღალი კლასი. NRC 0.95 — ხმის 95% შთანთქმა.

**სისტემის კომპონენტები**

- Armstrong Ultima+ პანელი 600x600მმ
- T-ბარ ლითონის კარკასი
- ჩამოკიდების სისტემა

**მონტაჟის ეტაპები**

1. კარკასის გეგმა — 600x600მმ ბადე
2. ჩამოკიდების ელემენტები ჭერზე
3. T-ბარ პროფილების მონტაჟი
4. Armstrong Ultima+ პანელების ჩასმა

**ღირებულება**

Armstrong Ultima+ სისტემა: 35-65 GEL/მ² (მასალა + სამუშაო)`,
    category: 'ინსტალაციის გზამკვლევი',
    author: 'გიორგი მამულაშვილი',
    authorRole: 'ტექნიკური სპეციალისტი',
    date: '2026-03-05',
    readTime: 6,
    image: 'https://readdy.ai/api/search-image?query=Modern%20office%20acoustic%20ceiling%20Armstrong%20panels%20installation%20professional%20interior%20design%20warm%20lighting%20photography&width=800&height=500&seq=blog-5-phoenix&orientation=landscape',
    tags: ['Armstrong', 'ჭერი', 'აკუსტიკა', 'ოფისი'],
    featured: false,
  },
  {
    id: 6,
    slug: 'fodbo-laminate-flooring-care',
    title: 'Fodbo ლამინირებული პარკეტის მოვლა: 10 მნიშვნელოვანი წესი',
    excerpt: 'გაიგეთ, როგორ გაახანგრძლივოთ Fodbo ლამინირებული პარკეტის სიცოცხლე 25+ წლამდე.',
    content: `Fodbo ლამინირებული პარკეტი 25 წლის გარანტიით მოდის — მაგრამ ეს გარანტია მოქმედებს მხოლოდ სწორი მოვლის შემთხვევაში.

**10 ძირითადი წესი**

1. **ყოველდღიური სუფთავება**: მშრალი ან ოდნავ ნოტიო მოწმენდა. ჭარბი წყალი — მტერი.

2. **ქიმიური საშუალებები**: მხოლოდ pH-ნეიტრალური. ქლორი, ამიაკი — დაუშვებელია.

3. **ავეჯის ფეხები**: ფელცის ბალიშები ყველა ავეჯის ფეხზე. ბრუნვადი სავარძლები — სპეციალური ხალიჩა.

4. **ტენიანობა**: ოთახის ტენიანობა 40-65%. ზამთარში ჰუმიდიფაიერი.

5. **ტემპერატურა**: 15-25°C. მკვეთრი ტემპერატურული ცვლილებები — მავნე.

6. **მზის სხივები**: პირდაპირი მზის სხივები ფერს ცვლის. ჟალუზი ან ფარდა.

7. **ლაქები**: დაუყოვნებლივ წაშლა. ღვინო, ყავა — ნეიტრალური სარეცხი.

8. **ქვიშა**: კარის წინ ხალიჩა — ქვიშა ყველაზე დიდი მტერია.

9. **გათბობა**: ქვეშ გათბობა — მაქსიმუმ 27°C. Fodbo-ს ყველა ფილა თავსებადია.

10. **შეკეთება**: მცირე ნაკაწრები — სპეციალური Fodbo-ს შეკეთების კომპლექტი.`,
    category: 'მოვლა',
    author: 'ნინო ჩიქოვანი',
    authorRole: 'ინტერიერის დიზაინერი',
    date: '2026-02-20',
    readTime: 4,
    image: 'https://readdy.ai/api/search-image?query=Laminate%20flooring%20maintenance%20cleaning%20professional%20warm%20oak%20wood%20floor%20elegant%20interior%20warm%20lighting%20photography&width=800&height=500&seq=blog-6-phoenix&orientation=landscape',
    tags: ['Fodbo', 'ლამინატი', 'მოვლა', 'გზამკვლევი'],
    featured: false,
  },
];

export const blogCategories = [
  'ყველა',
  'პროდუქტის გზამკვლევი',
  'ინსტალაციის გზამკვლევი',
  'შედარება',
  'ტრენდები',
  'მოვლა',
];